export default {
  methods: {

    checkStocks () {
      const warehouseCode = this.user.location_code

      if (!warehouseCode) {
        return this.swalInvalid('<h6>Please selecte a location first</h6>')
      }

      const productCodes = this.$refs.componentProducts.getFinalProducts().map(
        detail => detail.product_code
      ).filter(code => code)

      if (productCodes.length === 0) {
        return this.swalInvalid('<h6>Please select a product first</h6>')
      }

      this.getStocks(this, warehouseCode, productCodes).finally(() => {
        this.$refs.componentProducts.setStocksOfProducts(this.options.stocks)
      })

      this.$root.$emit('bv::hide::tooltip')
    },

    createRequest () {
      this.editing = false

      this.editAsDraft = true

      this.stockRequest = Object.assign(this.stockRequest, {
        id: '',
        stage: 0,
        destination: '',
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          destination: '',
          destination_name: '',
          destination_code: ''
        },
        delivery_details: {
          is_urgent: 0,
          date: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver_name: '',
          mobile_number: '',
          helper: ''
        },
        details: Array.from({ length: 5 }).map(
          () => ({
            product: null,
            quantity: null,
            onhand_quantity: 0
          })
        ),
        remarks: ''
      })

      this.getDestinations(this).finally(() => {
        this.getProducts(this)
      })

      this.$bvModal.show('modalRequest')
    },

    submitRequest (remarks = '') {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srPending.create({
        id: id,
        destination: headers.destination,
        remarks: remarks,
        delivery_details: {
          is_urgent: delivery_details.is_urgent,
          date: delivery_details.date,
          vehicle_plate: delivery_details.vehicle_plate,
          vehicle_name: delivery_details.vehicle_name,
          driver_name: delivery_details.driver_name,
          mobile_number: delivery_details.mobile_number,
          helper: delivery_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        active: 1
      }).then(() => {
        this.currentTabIndex = 0
      }).catch(
        errors => {
          if (errors.errors) {
            this.$refs.formStockRequest.setErrors({
              'headers.destination': errors.errors?.destination || [],
              'headers.category': errors.errors?.category || []
            })
            this.$refs.formDelivery.setErrors(errors.errors)
            this.setProductErrors(errors.errors)
          }
        }
      )
    }
  }
}
